import { appExperienceShareConfig, trendsShareConfig } from '@components/share/utils';
import { DASHBOARD_TYPE, DASHBOARD_URL } from '@utils/constants';
import { MODE_AI_ALERT_DIAGNOSTICS } from '@store/trends/constants';

export const getShareConfig = (baseUrl, isAppModule, mode) => {
  const eiShareUrl =
    mode === MODE_AI_ALERT_DIAGNOSTICS
      ? 'dashboard/ai-alerts/diagnostics/sharing'
      : 'dashboard/trends/sharing';

  const appShareUrl = 'dashboard/app-experience/sharing';

  const savedDashboardUrl = isAppModule
    ? DASHBOARD_URL[DASHBOARD_TYPE.APP_EXPERIENCE].slice(0, -1)
    : DASHBOARD_URL[DASHBOARD_TYPE.TRENDS].slice(0, -1);

  return {
    ...(isAppModule ? appExperienceShareConfig : trendsShareConfig),
    url: `${baseUrl}/${isAppModule ? appShareUrl : eiShareUrl}`,
    savedDashboardUrl: `${savedDashboardUrl}`,
  };
};

export const SUMMARY_PANEL_CONTROLS_ID = 'summary-panel-controls-wrapper';
